import React, { useContext, useState, useEffect, useMemo } from 'react';
import { fetchData } from '../service/data.service';

const SleepContext = React.createContext();

export const useSleepContext = () => useContext(SleepContext);

export function SleepProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [experience, setExperience] = useState({});
  const [sharedApp, setSharedApp] = useState({});
  const [article, setArticle] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/247873fd-5795-4e50-9c1c-92d9f6a8740c').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/c75a86c2-f853-40c0-8848-6088ce17b409')
      .then(setExperience);
    fetchData
      .get('https://run.mocky.io/v3/1738781c-f579-4507-b55b-7094db9b778a')
      .then(setSharedApp);
    fetchData.get('https://run.mocky.io/v3/640b1744-af69-4bb1-b4bf-74be9f727ba0').then(setArticle);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      experience,
      sharedApp,
      article,
      videos,
    }),
    [banner, experience, sharedApp, article, videos]
  );

  return <SleepContext.Provider value={value}>{children}</SleepContext.Provider>;
}
